<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="zone-container">
    <div
      :style="bannerImage"
      class="banner-img">
      <div class="btn-route">
        <i
          class="icon-arrow-left"
          @click="goToBack"/>
        <span>{{ nameRoute }}</span>
      </div>
      <div class="data-event-container">
        <div class="data-event-content">
          <h1>{{ event.name }}</h1>
        </div>

      </div>
    </div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="icon-bullet-icon">
        <el-breadcrumb-item :to="{ name: 'Home' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Eventos</el-breadcrumb-item>
        <el-breadcrumb-item>{{ event.name }}</el-breadcrumb-item>
        <el-breadcrumb-item>Selección de Zona</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="grid-container">
      <div class="grid-content">
        <el-row>
          <el-col
            :xs="24"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
            class="div-data-zone">
            <div class="data-event-zone">
              <div class="date-event-zone">
                <div class="calendar">
                  <div class="month">
                    {{ momentMT(getLocal.date).format('MMMM').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ momentMT(getLocal.date).format('DD') }}
                  </div>
                </div>
                <div class="date">
                  <span >{{ momentMT(getLocal.date).format('dddd, DD [de] MMMM YYYY') }}</span>
                </div>
              </div>
              <div class="place-event-zone">
                <i class="icon-map-pin"/>
                <span>{{ getLocal.venue }}</span>
              </div>
              <div class="hour-event-zone">
                <i class="icon-clock"/>
                <span>{{ getLocal.hour }}hrs</span>
              </div>
            </div>
            <br><br>
            <div class="hidden-xs-only">
              <mt-secure-buy/>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="17"
            :md="17"
            :lg="17"
            :xl="17"
            :offset="1"
            class="grid-zone-selection">
            <div class="template-venues">
              <div class="header-zone">
                <span>Selecciona la zona</span>
              </div>
            </div>
          </el-col>
          <div class="hidden-sm-and-up">
            <mt-secure-buy/>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import mtSecureBuy from '../_shared/mt-secure-buy'

export default {
  name: 'ZoneSelection',
  components: {
    mtSecureBuy
  },
  props: {
    nameRoute: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      event: {},
      fullscreenLoading: false,
      momentMT: moment
    }
  },
  computed: {
    getLocal () {
      return JSON.parse(localStorage.getItem('infoEvent'))
    },
    bannerImage () {
      return {
        backgroundImage: 'url(' + this.event.coverImage + ')'
      }
    },
    profileImg () {
      return {
        backgroundImage: 'url(' + this.event.thumbImage + ')'
      }
    }
  },
  mounted () {
    this.fullscreenLoading = true
    this.$store.dispatch('events/get', {id: this.$route.params.id}).then((response) => {
      this.event = response.data
    }).catch((e) => {
    }).finally(() => {
      this.fullscreenLoading = false
    })
  },
  methods: {
    goToBack () {
      this.$router.go(-1)
      localStorage.clear()
    }
  }
}
</script>

<style lang="scss" scoped>

  .div-data-zone{
  }
  .grid-container {
    margin-bottom: 0;
  }

  .zone-container {
    margin-top: 70px;
    //border: 1px solid blue;
    @media #{$Elementxs} {
      margin-top: 50px;
    }
  }

  .banner-img {
    height: 260px;
    background-size: cover;
    background-position: center;
    position: relative;
    .data-event-container {
      width: 100%;
      position: absolute;
      bottom: 65px;
      .data-event-content {
        width: 1280px;
        margin: 0 auto;
        @media #{$Laptop} {
          width: 100%;
          padding-left: 50px;
        }
        @media #{$Elementxs} {
          width: 100%;
          padding-left: 20px;
        }
        h1 {
          color: white;
          margin: 0;
        }
      }
    }
  }

  .data-event-zone {
    background-color: white;
    border-radius: 2px;
    padding: 20px;
    i {
      color: $roseHeader;
      font-size: 14px;
      margin-right: 14px;
    }
    .date-event-zone {
      display: flex;
      border-bottom: 1px solid #E3E6EA;
      padding-bottom: 20px;
      margin-bottom: 15px;
      .date{
        span{
          text-transform: uppercase;
          @include font-primary(14px, semibold);
          color: #444444;
        }
      }
    }
    .place-event-zone {
      margin-bottom: 10px;
      span{
        @include font-primary(14px, regular);
        color: #777777;
      }

    }
    .hour-event-zone {
      span{
        @include font-primary(14px, regular);
        color: $carbon;
      }
    }
  }

  .template-venues {
    background: url('~@/assets/images/grid.svg') repeat;
    border-radius: 2px;
    background-size: 50px;
    height: 500px;
    padding: 30px;
    .header-zone {
      padding-bottom: 15px;
      border-bottom: 1px solid #E3E6EA;
      span {
        @include font-primary(14px, semibold);
      }
    }
  }

  .calendar {
    background-color: #2894FF;
    border-radius: 2px;
    height: 40px;
    width: 40px;
    margin-right: 17px;
    text-align: center;
    position: relative;
    padding: 1px;
    .month {
      text-transform: uppercase;
      color: white;
      border-radius: 2px 2px 0 0;
      @include font-primary(8px, regular);
    }
    .day {
      background-color: white;
      @include font-primary(18px, regular);
      color: #2894FF;
      line-height: 25px;
      height: 27px;
      border-radius: 0 0 2px 2px;
    }
  }
.grid-zone-selection{
  @media #{$Elementxs} {
    margin: 0;
  }
}
  @media only screen and (max-width: 1191px) {
    .calendar {
      min-width: 40px;
    }
    .hidden-available {
      .el-tag {
        padding: 0 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/zone-selection/zone-selection.vue